module.exports = __webpack_public_path__ + "img/service-content-time-excel@3x.a9eaa3cf.png";